// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Img from 'components/Image';
import Staff from 'logo-staff.svg';
import Salary from 'logo-salary.svg';
import Idealist from 'logo-idealist.svg';

const LogoContainer = styled(Box)`
  svg,
  canvas,
  img {
    height: 100%;
    width: auto;
  }
`;

const Logo = ({
  staff,
  salary,
  height,
  ...props
}: {
  staff?: boolean,
  salary?: boolean,
  height: mixed
}) => (
  <LogoContainer position="relative" height={height} {...props}>
    <canvas width="167.883" height="167.883" />
    <Box position="absolute" height="100%" left={0} top={0}>
      <Box
        component={Img}
        width={72}
        height={72}
        layout="responsive"
        flex="0 0 auto"
        src="/static/images/logo-mark.png"
        srcSet="/static/images/logo-mark.png, /static/images/logo-mark@2x.png 2x, /static/images/logo-mark@3x.png 3x"
        alt="Idealist logo"
        webp
        alwaysShow
      />
    </Box>
    <canvas width="41.379" height="167.883" />
    {salary ? (
      <>
        <canvas width="12" height="167.883" />
        <Box height="100%" position="relative" display="inline-block">
          <canvas width="320" height="167.883" />
          <Box position="absolute" top={0} left={0} width="100%" height="100%">
            <Salary />
          </Box>
        </Box>
      </>
    ) : (
      <Box height="100%" position="relative" display="inline-block">
        <canvas width="347.913" height="167.883" />
        <Box position="absolute" top={0} left={0} width="100%" height="100%">
          <Idealist />
        </Box>
      </Box>
    )}
    {staff && (
      <>
        <canvas width="45.976" height="167.883" />
        <Box height="100%" position="relative" display="inline-block">
          <canvas width="184.444" height="167.883" />
          <Box position="absolute" top={0} left={0} width="100%" height="100%">
            <Staff />
          </Box>
        </Box>
      </>
    )}
  </LogoContainer>
);

export default Logo;
